import { createTheme, loadTheme } from '@fluentui/react'

/**
 * generated using https://fabricweb.z5.web.core.windows.net/pr-deploy-site/refs/heads/master/theming-designer/index.html
 * @type {{themeLight: string, themeLighterAlt: string, themeLighter: string, themeTertiary: string, neutralLighterAlt: string, neutralPrimaryAlt: string, neutralLighter: string, black: string, themePrimary: string, themeSecondary: string, themeDarkAlt: string, themeDarker: string, neutralTertiaryAlt: string, neutralDark: string, white: string, neutralQuaternary: string, neutralQuaternaryAlt: string, neutralSecondary: string, neutralPrimary: string, themeDark: string, neutralTertiary: string, neutralLight: string}}
 */
export const palette = {
  themePrimary: '#0a055f',
  themeLighterAlt: '#d2d1ec',
  themeLighter: '#adaada',
  themeLight: '#8b88c8',
  themeTertiary: '#6d69b7',
  themeSecondary: '#524da5',
  themeDarkAlt: '#3a3693',
  themeDark: '#262282',
  themeDarker: '#161170',
  neutralLighterAlt: '#faf9f8',
  neutralLighter: '#f3f2f1',
  neutralLight: '#edebe9',
  neutralQuaternaryAlt: '#e1dfdd',
  neutralQuaternary: '#d0d0d0',
  neutralTertiaryAlt: '#c8c6c4',
  neutralTertiary: '#a19f9d',
  neutralSecondary: '#605e5c',
  neutralPrimaryAlt: '#3b3a39',
  neutralPrimary: '#323130',
  neutralDark: '#201f1e',
  black: '#000000',
  white: '#ffffff',
  highlightTertiary: '#0cc4c4',
  lightgrey: 'lightgrey',
  // colors to highlight red/yellow/green health scores
  lightred: '#ff684c',
  lightyellow: '#ffda66',
  lightorange: '#ffb933',
  lightgreen: '#8ace7e',
  lightblue: '#6d69b7',
  messageblue: '#1982FC',
}

export const themeSettings = {
  defaultFontStyle: {
    fontFamily: `'DM Sans', sans-serif`,
  },
  palette,
}

export function set() {
  loadTheme(createTheme(themeSettings))
}
